
export function renderNetraaLHReleaseNotes4 () {
    return (
  <div>
    <main className="transition-opacity duration-300">
      <div className="py-4">

        {/* Header */}
        <div id="introduction" className="mb-10 scroll-mt-24">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-wider text-orange-600 uppercase bg-orange-100 rounded-full dark:bg-orange-900/30 dark:text-orange-400">
            Release Notes
          </span>

          <h1 className="text-3xl lg:text-4xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
              Netraa LH Release Notes
            </span>
          </h1>

          <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
            Latest updates including feature enhancements, performance improvements, and bug fixes.
          </p>
        </div>

        {/* Confidentiality */}
        {/* <div id="confidentiality" className="scroll-mt-24 bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 p-4 mb-10 rounded-r-lg">
          <h4 className="text-sm font-bold text-red-800 dark:text-red-300 mb-2">
            Confidentiality Statement
          </h4>
          <p className="text-xs text-red-700 dark:text-red-400 leading-relaxed">
            The information contained in any Communication or Documentation distributed by ApMoSys, including attachments, is strictly confidential and intended solely for delivery to, and authorized use by, the identified addressee(s), as it may contain legally privileged and/or confidential information. If you are not the intended recipient of the Communication, you are hereby notified that any reading, disclosure, dissemination, distribution or copying of the Communication, and any attachments thereto, is strictly prohibited. If you have received the Communication in error, please notify the sender immediately and delete the message, and any copies and printouts thereof, from your records.
          </p>
        </div> */}

        {/* Document Authors */}
        <section id="overview" className="scroll-mt-24 mt-10 mb-12">
          <h2 className="text-xl font-bold text-text-main dark:text-white mb-4">
            Release Details
          </h2>

          <div className="overflow-x-auto border border-border-color dark:border-border-dark rounded-xl">
            <table className="w-auto text-left border-collapse text-sm">
              <thead>
                <tr>
                  <th className="px-4 py-3 font-bold text-text-muted">Release Date</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Release Type</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Author Name</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-3 font-medium text-primary">25th Feb 2026</td>
                  <td className="px-4 py-3">Enhancements & Fixes</td>
                  <td className="px-4 py-3">Navodya Tyagi</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Introduction */}
        <section id="" className="scroll-mt-24 mb-12">
          <div className="p-6 rounded-2xl bg-gradient-to-r from-orange-50 to-transparent dark:from-orange-900/20 dark:to-transparent border border-border-color dark:border-border-dark">
            
            <h2 className="text-2xl font-bold text-text-main dark:text-white mb-3">
              Introduction
            </h2>

            <p className="text-sm text-text-muted dark:text-gray-400 leading-relaxed">
              We are excited to announce the latest updates to our platform Netraa LH, packed with several feature enhancements, improvements, and bug fixes. This release aims to provide a better user experience, streamline processes, and increase overall efficiency.
            </p>

          </div>
        </section>

        {/* Release Notes */}
        <section id="release-notes" className="scroll-mt-24 mb-16">
          <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6">
            Release Notes
          </h2>

          <div className="space-y-8">

            {/* Enhancements Block */}
            <div id="enhancements" className="scroll-mt-24 p-6 rounded-2xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark">
              
              <h3 className="text-lg font-bold text-text-main dark:text-white mb-5">
                1. Enhancements
              </h3>

              <div className="space-y-5">

                {[
                  {
                    title: "Application & Navigation Improvements",
                    items: [
                      "Added a direct “Live Dashboard” button on the Landing (Application) page.",
                      "Selecting a specific application from the Application page now redirects to the Monitors (KPI Dashboard) page for the selected client.",
                      "Introduced sorting of Applications based on key KPIs:",
                      "Monitor Count",
                      "Error Count",
                      "Locations Monitored Count",
                      "Average Run Time",
                      "Enabled ascending and descending sorting for Applications."
                    ]
                  },
                  {
                    title: "Client Management (Admin Role)",
                    items: [
                      "Introduced a Client Filter option for Admin users to switch between multiple clients.",
                      "The Client Filter now has a global impact across Availability, Error, and other modules."
                    ]
                  },
                  {
                    title: "Live Dashboard Improvements",
                    items: [
                      "Improved monitor search functionality (bug fix).",
                      "Fixed the one-click view for Historical Data.",
                      "Enhanced visibility of the Expected Run Count in the Historical Data table."
                    ]
                  },
                  {
                    title: "“What Went Wrong” Page Enhancements",
                    items: [
                      "Added an SLA Frequency Table with daily and consolidated live data views.",
                      "Introduced a one-click Historical Data button.",
                      "Added timestamps for Run Status under Historical Data.",
                      "Included Start Time, End Time, and Execution Duration on Run Status graph bars.",
                      "Added runtime delta comparison with respect to the previous run."
                    ]
                  },
                  {
                    title: "Availability Module Enhancements",
                    items: [
                      "Successful Executions are now displayed in green (previously purple).",
                      "Added Start Time and End Time under Executions in the monitor table."
                    ]
                  },
                  {
                    title: "Performance & Visualization Improvements",
                    items: [
                      "Enhanced the End User Response Time (s) graph to span the full screen width."
                    ]
                  }
                ].map((section, i) => (

                  <div
                    key={i}
                    className="flex gap-4 p-4 rounded-xl bg-white/50 dark:bg-white/5 border border-border-color dark:border-border-dark"
                  >

                    {/* Number Badge */}
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-600 text-sm font-bold flex-shrink-0">
                      {`1.${i + 1}`}
                    </div>

                    {/* Content */}
                    <div className="flex-1">
                      <h4 className="font-semibold text-text-main dark:text-white mb-2">
                        {section.title}
                      </h4>

                      <ul className="list-disc pl-5 space-y-1 text-sm text-text-muted dark:text-gray-400">
                        {section.items.map((item, idx) => (
                          <li key={idx}>{item}</li>
                        ))}
                      </ul>
                    </div>

                  </div>

                ))}

              </div>
            </div>

            {/* UI Updates Block */}
            <div id="ui-updates" className="scroll-mt-24 p-6 rounded-2xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark">
              
              <h3 className="text-lg font-bold text-text-main dark:text-white mb-4">
                2. UI & Communication Updates
              </h3>

              <div className="flex gap-4 p-4 rounded-xl bg-white/50 dark:bg-white/5 border border-border-color dark:border-border-dark">

                <ul className="list-disc pl-5 space-y-1 text-sm text-text-muted dark:text-gray-400">
                  <li>Updated the OTP login email body to include the username for better clarity.</li>
                </ul>

              </div>

            </div>

          </div>
        </section>

      </div>
    </main>
  </div>
);
}